// extracted by mini-css-extract-plugin
export default {"screen":"Started_screen__Oh+I5"};